import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Alert } from 'reactstrap';
import './index.css';

const PermissionError = ({ isOpen, toggle, error, onRequestAccess, hideClose = false }) => {
  // Parse error message to extract details
  const parseErrorMessage = (message) => {
    if (!message) return { title: 'Permission Required', message: 'You don\'t have permission to perform this action.' };

    // The backend now sends user-friendly messages
    return { title: 'Permission Required', message: message };
  };

  const { title, message } = parseErrorMessage(error);

  return (
    <Modal
      isOpen={isOpen}
      toggle={hideClose ? undefined : toggle}
      centered
      className="main-modal new-user-modal modal-dialog-centered create-label-modal"
      backdrop={hideClose ? 'static' : true}
      keyboard={!hideClose}
    >
      <ModalHeader toggle={hideClose ? undefined : toggle}>
        <h3>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="mr-2">
            <circle cx="12" cy="12" r="10" fill="#FEE2E2" />
            <path d="M12 8V12" stroke="#EF4444" strokeWidth="2" strokeLinecap="round" />
            <circle cx="12" cy="14" r="0.5" fill="#EF4444" />
          </svg>
          {title}
        </h3>
      </ModalHeader>
      <ModalBody>
        <div className='filters-modal-content bug-modal-show mt-4'>
          <Alert color="warning" className="">
            <p className="mb-0" dangerouslySetInnerHTML={{ __html: message }}></p>
          </Alert>

          <div className="permission-help-text mt-3">
            <h6>What can you do?</h6>
            <ul className="ps-3">
              <li>Contact your workspace administrator for access</li>
              <li>Check if you're in the correct workspace</li>
              <li>Verify your account permissions with your team</li>
            </ul>
          </div>
          {!hideClose && (
            <div className="permission-btns mt-4 d-flex justify-content-end">
              {onRequestAccess && (
                <button className="btn-style-border mr-3" onClick={onRequestAccess}>
                  Request Access
                </button>
              )}
              <button className="btn-style-new" onClick={toggle}>
                Close
              </button>
            </div>
          )}
        </div>
      </ModalBody>
    </Modal>
  );
};

export default PermissionError;